import React from 'react';
import get from 'lodash/get';
import { connect } from 'react-redux';
import moment from 'moment-timezone';
import { Link } from 'react-router-dom';
import {Alert, Icon, Layout, Table, Badge,Select, Button, Modal, Switch, message, Tooltip, Breadcrumb, Input} from 'antd';

import SettingsUserForm from '../../components/SettingsUserForm/SettingsUserForm';
import classes from './SettingsUsers.css';

import isAuthenticated from '../../utils/isAuthenticated';
import { getSettingsUsersRequest, deleteUserRequest, activateUserRequest, getSitesRequest } from '../../api/requests';
import { logout } from "../../reducers/user/actions";
import {
  getUserCreatePermission,
  getUserUpdatePermission,
  getUserDeletePermission, getUserTimezone, getUserShortTimezone,
} from "../../reducers/user/selectors";
import {withParams} from "../../utils/url";
import { withNamespaces } from 'react-i18next';

const routes = require('../../routes.json');

const { Content } = Layout;
const { Search } = Input;

const { Option } = Select;

class SettingsUsers extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      nameSearch: null,
      usersList: [],
      errorMessage: '',
      responseMessage: '',
      userEdit: null,
      currentPage: 1,
      total: 1,
      pageSize: 25,
      additionalSiteAccess: null,
      sortedInfo: {},
      order: 'asc',
      filter: '',
      sites: [],
      site: null,
    };
  }

  async componentDidMount() {
    this.getUsersList();

    try {
      const { data } = await getSitesRequest();
      this.setState({ sites: data });
    } catch (e) { if (get(e, 'response.status') === 401) { this.props.logout();  return; } console.log(e);}
  }

  onNameSearch = async (value) => {
    this.setState({ nameSearch: value, currentPage: 1 }, this.getUsersList);
  };

  handleFilterChange = (value) => { this.setState({ filter: value, site: null, sortedInfo: null, currentPage: 1 }, this.getUsersList) };
  handleSiteChange = (value) => { this.setState({ site: value, sortedInfo: null, currentPage: 1 }, this.getUsersList) };
  clearFilters = () => { this.setState({ site: null, filter: null, sortedInfo: null, currentPage: 1 }, this.getUsersList); };

  getUsersList = async (page = this.state.currentPage, per_page = this.state.pageSize) => {
    this.setState({ errorMessage: null, isLoading: true, responseMessage: null });

    try {
      const { data } = await getSettingsUsersRequest({
        order_direction: this.state.order,
        order_column: get(this.state, 'sortedInfo.columnKey'),
        page,
        per_page,
        nameSearch: this.state.nameSearch,
        filter_by: this.state.filter,
        site_code: this.state.site,
      });
      this.setState({ usersList: data.data, total: data.total_pages * per_page, currentPage: page });
    } catch (e) {
      if (get(e, 'response.status') === 401) { this.props.logout();  return; }
      this.setState({ subject: null, errorMessage: get(e, 'response.data.error', 'Error') });
    }

    this.setState({ isLoading: false });
  };

  onSwitchUserActivation = (code, state) => async () => {
    try {
      if (state === 'active') {
        await deleteUserRequest(code);
      } else {
        await activateUserRequest(code);
      }

      message.success(this.props.i18n.t('Saved'));

      this.getUsersList();
    } catch (e) {
      if (get(e, 'response.status') === 401) { this.props.logout();  return; }
      message.error(get(e, 'response.data.error', 'Error'));
      console.log(e);
    }
  };

  onUserEdit = user => () => {
    this.setState({ userEdit: user });
  };

  onUserEditHide = () => {
    this.setState({ userEdit: null });
  };

  onUserEditSubmit = () => {
    this.setState({ userEdit: null }, this.getUsersList);
  };

  addUser = () => {
    this.setState({ userEdit: {} });
  };

  handleTableChange = (pagination, filters, sorter) => {
    this.setState({
      isLoading: true,
      pageSize: pagination.pageSize,
      sortedInfo: sorter,
      order: get(sorter, 'order') === 'ascend' ? 'asc' : get(sorter, 'order') === 'descend' ? 'desc' : 'asc',
    }, () => this.getUsersList(pagination.current, pagination.pageSize));
  };

  render() {
    const { usersList, errorMessage, filter, sites, site, responseMessage, isLoading, userEdit, currentPage, total, pageSize, additionalSiteAccess, sortedInfo, nameSearch } = this.state;
    const { userCreatePermission } = this.props;

    let columns = [
      /*{
        dataIndex: "code",
        key: "code",
        title: this.props.i18n.t('Code'),
        render: (val, record) => (<span>{val} &nbsp; <Badge count={record.state} style={{ backgroundColor: record.state === 'active' ? '#52c41a' : '#777' }} /></span>),
        sorter: true,
        sortOrder: get(sortedInfo, 'columnKey') === 'code' && sortedInfo.order,
      },*/
      {
        dataIndex: "username",
        key: "username",
        title: this.props.i18n.t('Username'),
        render: (val, record) => (<span>{val} &nbsp; <Badge count={record.state} style={{ backgroundColor: record.state === 'active' ? '#52c41a' : '#777' }} /></span>),
        sorter: true,
        sortOrder: get(sortedInfo, 'columnKey') === 'username' && sortedInfo.order,
      },
      {
        dataIndex: "name",
        key: "name",
        title: this.props.i18n.t('Name'),
        render: (val, record) => (<span>{val} {record.first_name} {record.last_name}</span>),
        sorter: true,
        sortOrder: get(sortedInfo, 'columnKey') === 'name' && sortedInfo.order,
      },
      {
        dataIndex: "email",
        key: "email",
        title: this.props.i18n.t('Email'),
        sorter: true,
        sortOrder: get(sortedInfo, 'columnKey') === 'email' && sortedInfo.order,
      },
      {
        dataIndex: "last_logged_in",
        key: "last_logged_in",
        title: this.props.i18n.t('NamespaceSettingsUsers:Last Logged In'),
        render: val => (<span>{val ? `${moment.utc(val).tz(this.props.userTimezone || 'UTC').format('YYYY-MM-DD HH:mm')} ${this.props.userShortTimezone || 'UTC'}` : 'No data'} </span>),
        sorter: true,
        sortOrder: get(sortedInfo, 'columnKey') === 'last_logged_in' && sortedInfo.order,
      },
      {
        dataIndex: "site_access_list",
        key: "site_access_list",
        title: this.props.i18n.t('NamespaceSettingsUsers:Site access'),
        render: val => (<div>
          {val.sort((a, b) => a.site.code - b.site.code).slice(0, 3).map(item => (
            item.state === 'active' && <p key={item.site.id}><b>{item.site.code} - {item.site.name}:</b> {item.user_role.name}</p>
          ))}

          {val.length > 3 && (
            <Button type="primary" size="small" htmlType="button" onClick={() => this.setState({ additionalSiteAccess: val.sort((a, b) => a.site.code - b.site.code).slice(3) })}>
              {this.props.i18n.t('NamespaceSettingsUsers:Additional site access')}
            </Button>
          )}
        </div>)
      },
      {
        dataIndex: "mode",
        key: "mode",
        title: this.props.i18n.t('NamespaceSettingsUsers:User Lock-out'),
        render: val => (<div>
          {val === true && this.props.i18n.t('NamespaceSettingsUsers:Automatic')}
          {val === false && this.props.i18n.t('NamespaceSettingsUsers:Manual')}
          {val === null && this.props.i18n.t('NamespaceSettingsUsers:Nothing')}
        </div>)
      },
      {
        dataIndex: "id",
        key: "id",
        title: this.props.i18n.t('Actions'),
        render: (id, user) => (<div className={classes.actions}>
          {user.is_editable && <Tooltip placement="topLeft" title={this.props.i18n.t('NamespaceSettingsUsers:Edit User')}>
            <Icon type="edit" theme="filled" className={classes.actionIcon} onClick={this.onUserEdit(user)} />
          </Tooltip>}
          <Tooltip placement="topLeft" title={this.props.i18n.t('User Role Management')}>
            <Link to={withParams(routes.admin.settingsUsersRoles, { userID: id })}><Icon type="control" theme="filled" className={classes.roleIcon} /></Link>
          </Tooltip>&nbsp;&nbsp;
          <div>
            <b></b><br/>
            <Tooltip placement="topLeft" title={this.props.i18n.t('NamespaceSettingsUsers:Activate / Deactivate User')}>
              <Switch disabled={(user.state === 'active' && !this.props.userDeletePermission) || (user.state === 'inactive' && !this.props.userUpdatePermission) } className={classes.reactivateBtn} checked={user.state === 'active'} onChange={this.onSwitchUserActivation(id, user.state)} />
            </Tooltip>

          </div>
        </div>)
      },
    ];

    return (
        <div style={{ backgroundColor: '#FAFAFA' }}>
            <Layout className={classes.parentContainer}>

                <Content className={classes.content}>
                  <h3 className='headline-default'>{this.props.i18n.t('User Management')}</h3>
                  <Breadcrumb>
                    <Breadcrumb.Item href='/admin/settings'>{this.props.i18n.t('Admin Settings')}</Breadcrumb.Item>
                    <Breadcrumb.Item>{this.props.i18n.t('User Management')}</Breadcrumb.Item>
                  </Breadcrumb>
                  <br/>
                  <div className={classes.searchWrapper}>
                    <label className={classes.searchWrapperSearch}>
                      <b className={classes.searchWrapperLabel}>{this.props.i18n.t('SEARCH')}</b>
                      <Search
                        placeholder={this.props.i18n.t('By name')}
                        enterButton={this.props.i18n.t('Search')}
                        size="large"
                        onSearch={this.onNameSearch}
                        value={nameSearch}
                        onChange={e => this.setState({ nameSearch: e.target.value })}
                        style={{ maxWidth: '500px'}}
                      />
                    </label>

                    <span className={classes.clearButton} onClick={() => this.onNameSearch('')}>{this.props.i18n.t('Clear')}</span>
                  </div>

                  <div className={classes.searchWrapperFilter}>
                      <label className={classes.searchWrapperFilterItem}>
                        <b className={classes.searchWrapperLabel}>{this.props.i18n.t('Filter by')}</b>
                        <Select onChange={this.handleFilterChange} value={filter} style={{ width: '100%' }} placeholder={this.props.i18n.t('Select')}>
                          <Option value='site'>{this.props.i18n.t('Site')}</Option>
                        </Select>
                      </label>

                      {filter === 'site' && (<label className={classes.searchWrapperFilterItem}>
                        <b className={classes.searchWrapperLabel}>{this.props.i18n.t('Site')}</b>
                        <Select onChange={this.handleSiteChange} value={site} style={{ width: '100%' }} placeholder={this.props.i18n.t('Select')}>
                          {sites.map(site => (
                            <Option key={site.id} value={site.code}>{site.code} - {site.name}</Option>
                          ))}
                          <Option value=''>{this.props.i18n.t('All sites')}</Option>
                        </Select>
                      </label>)}

                      <span className={classes.clearButton} onClick={this.clearFilters}>{this.props.i18n.t('Clear')}</span>
                  </div>
                  {errorMessage && (<Alert type='error' message={errorMessage} />)}

                  {responseMessage && (<Alert type='success' message={responseMessage} />)}

                  {userCreatePermission && <div><Button type='primary' onClick={this.addUser}>{this.props.i18n.t('Add user')}</Button><br/><br/></div>}

                  <Table
                    columns={columns}
                    dataSource={usersList}
                    loading={isLoading}
                    rowKey="id"
                    onChange={this.handleTableChange}
                    pagination={{
                      onShowSizeChange: (current, size) => {
                        this.setState({ pageSize: size });
                      },
                      current: currentPage,
                      total,
                      pageSize,
                      showSizeChanger: true,
                      pageSizeOptions: ['10', '25', '50', '100'],
                      position: 'both',
                    }}
                  />


                  <Modal
                    visible={!!userEdit}
                    onCancel={this.onUserEditHide}
                    footer={null}
                  >
                    {userEdit && <SettingsUserForm {...userEdit} isNew={userEdit && !userEdit.id} onSubmit={this.onUserEditSubmit} onCancel={this.onUserEditHide} />}
                  </Modal>


                  <Modal
                    title={this.props.i18n.t('NamespaceSettingsUsers:Additional site access')}
                    visible={!!additionalSiteAccess}
                    onCancel={() => { this.setState({ additionalSiteAccess: null }) }}
                    footer={null}
                  >
                    {additionalSiteAccess && additionalSiteAccess.sort((a, b) => a.site.code - b.site.code).map(item => (
                      item.state === 'active' && <p key={item.site.id}><b>{item.site.code} - {item.site.name}:</b> {item.user_role.name}</p>
                    ))}
                  </Modal>

                </Content>

            </Layout>
        </div>
    );
  }
}

const mapStateToProps = (state) => ({
  userTimezone: getUserTimezone(state),
  userShortTimezone: getUserShortTimezone(state),
  userCreatePermission: getUserCreatePermission(state),
  userDeletePermission: getUserDeletePermission(state),
  userUpdatePermission: getUserUpdatePermission(state),
});

const mapDispatchToProps = { logout };

export default isAuthenticated(connect(mapStateToProps, mapDispatchToProps)(withNamespaces()(SettingsUsers)));



// WEBPACK FOOTER //
// ./src/containers/SettingsUsers/SettingsUsers.js